import { Injectable } from '@angular/core';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { environment } from 'environments/environment';
import {Observable} from 'rxjs/Observable';
import { map } from 'rxjs/operators';

declare const firebase: any;
@Injectable()
export class TicketService {

  constructor(private sweetAlertHelper: SweetAlertHelper) {}

  storeTicket(support: any, screenshot: any) {
    const nameImg = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + '.jpeg';
    const user = JSON.parse(localStorage.getItem('currentUser'));
    const hoy = new Date();
    const fecha = hoy.getDate() + '-' + (hoy.getMonth() + 1) + '-' + hoy.getFullYear();
    const hora = hoy.getHours() + ':' + hoy.getSeconds() + ':' + hoy.getSeconds();
    const ticket_number = `TR2-${hoy.getFullYear()}${(hoy.getMonth() + 1)}${hoy.getDate()}-${hoy.getHours()}${hoy.getMinutes()}`;
    const errorDetalls = {
      id: 0,
      ticket_number: ticket_number,
      img: null,
      domain: window.location.hostname,
      userprofileid: user.userprofileid,
      user: user,
      date: fecha + ' ' + hora,
      ua: navigator.userAgent,
      url: window.location.href,
      status: 'Open',
      screenshot: null,
      support: support,
      versions: {
        local: environment.version,
        name_env: environment.name_env,
        remote: window.localStorage.getItem('remoteVersion')
      }
    };

    if (screenshot) {
      errorDetalls.img = nameImg;
      errorDetalls.screenshot = screenshot;
      firebase.firestore().collection('TicketsSupport').add(errorDetalls)
      .then((x: any) => this.sweetAlertHelper.createCustomAlert({
        title: 'Attention',
        text: 'You ticket number is : ' + ticket_number,
        type: 'success'
      }));
    } else {
      firebase
        .firestore()
        .collection('TicketsSupport')
        .add(errorDetalls)
        .then((x: any) =>
          this.sweetAlertHelper.createCustomAlert({
            title: 'Attention',
            text: 'You ticket number is : ' + ticket_number,
            type: 'success',
          })
        );
    }
  }

  getAllTicket(): Observable<any> {
    return new Observable<any>(data => {
      firebase.firestore().collection('TicketsSupport').onSnapshot({
        includeMetadataChanges: true
      }, (doc: any) => {
          const tem = [];
          doc.forEach((childSnapshot: any) => {
            tem.push({ id: childSnapshot.id, data: childSnapshot.data()});
          });
          data.next(tem);
      });
    });
  }

  deleteTicket(idDocument: string): void {
    firebase.firestore().collection('TicketsSupport').doc(idDocument)
    .delete().then((res: any) => {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Success',
        text: 'Document successfully deleted!',
        type: 'success'
      });
    }).catch((error: any) => {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: 'Error removing document:' + error,
        type: 'error'
      });
    });
  }

  changeStatusTicket(value: string, idDocument: string): void {
    firebase.firestore().collection('TicketsSupport').doc(idDocument)
    .set({ status: value }, { merge: true }).then((res: any) => {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Success',
        text: 'Document Successfully Written!',
        type: 'success'
      });
    }).catch((error: any) => {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: 'Error writing document:' + error,
        type: 'error'
      });
    });
  }

  assignedTo(user: { email: string, name: string }, idDocument: string): void {
    firebase.firestore().collection('TicketsSupport').doc(idDocument)
    .set({
      assigned_to: user.email,
      assigned_to_name: user.name
    }, { merge: true }).then((res: any) => {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Success',
        text: 'Document successfully written!',
        type: 'success'
      });
    }).catch((error: any) => {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        text: 'Error writing document:' + error,
        type: 'error'
      });
    });
  }

  sendMessage(messages, id, status) {
    const hoy = new Date();
    const fecha = hoy.getDate() + '-' + (hoy.getMonth() + 1) + '-' + hoy.getFullYear();
    const hora = hoy.getHours() + ':' + hoy.getSeconds() + ':' + hoy.getSeconds();
    const randomID = firebase.database().ref().child('TicketsSupport').push().key;

    firebase.database().ref('TicketsSupport/' + id + '/messages/' + randomID).update({
        messages: messages,
        date: fecha + ' ' + hora,
        status: status
    });
  }

  getTicket(id: string): Observable<any> {
    return Observable.fromPromise(
      firebase.firestore().collection('TicketsSupport')
      .doc(id)
      .get()
    ).pipe(
      map(
        (x: any) => x.data()
      )
    );
  }

  getTicketForUser(userprofileid: number): Observable<any> {
    return Observable.fromPromise(
      firebase.firestore().collection('TicketsSupport')
      .where('userprofileid', '==', userprofileid)
      .get()
    ).pipe(
      map( (snapshot: any) => {
        const tem = [];
        snapshot.forEach((childSnapshot: any) => {
          tem.push(childSnapshot.data());
        });
        return tem;
      })
    );
  }

  getUserForSupport() {
    const user = [
      {email: 'omarenco@transportationamerica.com', name: 'Omar Marenco'},
      {email: 'ngonzalez@transportationamerica.com', name: 'Naycool Gonzalez'},
      {email: 'lmeza@transportationamerica.com', name: 'Luis Meza'},
      {email: 'jverbel@transportationamerica.com', name: 'Josue Verbel'},
      {email: 'nmartinez@transportationamerica.com', name: 'Nivaldo Martinez Urueta'},
      {email: 'jvelez@transportationamerica.com', name: 'Jonathan Velez'},
      {email: 'mlopeza@transportationamerica.com', name: 'Miguel Lopez Ariza'},
    ];
    return user;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/debuger-app/services/ticket.service.ts